<template>
  <div class="lottery_content">
    <ul>
      <div class="swiper">
        <div class="swiper-wrapper" ref="slides">
          <img
            v-for="(item, index) in state.rewardList"
            :key="index"
            :src="item.image"
            :alt="item.alt"
            class="swiper-slide"
          />
        </div>
      </div>
    </ul>
    <!-- 两侧 -->
    <img
      src="../../../../assets/webActivity/newYear/lotteryImg/first_gift.png"
      alt=""
      class="slide_left animate__animated animate__pulse"
    />
    <a @click="scrollTofirst" class="slide_right">
      <img :src="props.first.avatar" alt="" />
      <span>
        <van-notice-bar :text="props.first.user_nicename" :speed="30" />
      </span>
    </a>

    <!-- 宝箱 -->
    <div class="box">
      <Lottie class="lottiebox" :options="notOpenOptions" />
      <p class="animate__pulse animate__animated">
        剩余开箱数：{{ props.cjnum }}
      </p>
    </div>
    <!-- 开启按钮 -->
    <div class="open_box">
      <button @click="openBox('1')"></button>
      <button @click="openBox('10')"></button>
    </div>
    <van-popup
      v-model:show="state.openFlag"
      class="open_box_pop"
      @opened="openBoxPop"
      @closed="closeBoxPop"
      :close-on-click-overlay="false"
    >
      <div class="open_pop_content" ref="openboxDom" :style="{ height: '70%' }">
        <!-- <div class="open_pop_content" ref="openboxDom"> -->
        <Lottie class="lottiebox" :options="openOptions" :key="state.openKey" />
        <img
          src="../../../../assets/webActivity/newYear/lotteryImg/lottery_award_title.png"
          alt=""
          class="award_title"
          v-show="state.awardTitleFlag"
        />
        <ul
          v-if="state.awardFlag"
          :class="state.awardList.length > 1 ? 'awardList' : ''"
        >
          <li
            class="animate__animated animate__flip"
            v-for="(item, index) in state.awardList"
            :key="index"
          >
            <img :src="item.image" alt="" />
          </li>
        </ul>
        <img
          src="../../../../assets/webActivity/newYear/lotteryImg/lottery_getBtn.png"
          alt=""
          class="get_btn"
          v-show="state.getAwardflag"
          @click="getAward"
        />
      </div>
    </van-popup>
  </div>
</template>
<script setup>
import "animate.css";
import { onMounted, nextTick, reactive, ref } from "vue";
import touxiang from "../../../../assets/touxiang_reset.png";

// 页面动画相关

import Lottie from "vue-lottie/src/lottie.vue";
import notOpen from "../../../../assets/webActivity/newYear/lotteryImg/not_open.json";
import open from "../../../../assets/webActivity/newYear/lotteryImg/open.json";
const notOpenOptions = {
  animationData: notOpen,
  loop: true,
  autoplay: true,
};
const openOptions = {
  animationData: open,
  loop: false,
  autoplay: true,
};

const state = reactive({
  // 是否弹出
  openFlag: false,
  openKey: 0,

  // 是否展示奖励
  awardFlag: false,
  // 是否展示领取按钮
  getAwardflag: false,
  awardTitleFlag: false,

  // 奖励列表
  rewardList: [
    {
      image: require("../../../../assets/webActivity/newYear/lotteryImg/score_1.png"),
      alt: "1积分",
    },
    {
      image: require("../../../../assets/webActivity/newYear/lotteryImg/score_2.png"),
      alt: "2积分",
    },
    {
      image: require("../../../../assets/webActivity/newYear/lotteryImg/score_3.png"),
      alt: "3积分",
    },
    {
      image: require("../../../../assets/webActivity/newYear/lotteryImg/score_6.png"),
      alt: "6积分",
    },
    {
      image: require("../../../../assets/webActivity/newYear/lotteryImg/coupon_6.png"),
      alt: "6元优惠券",
    },
    {
      image: require("../../../../assets/webActivity/newYear/lotteryImg/coupon_10.png"),
      alt: "10元优惠券",
    },
    {
      image: require("../../../../assets/webActivity/newYear/lotteryImg/coin_10.png"),
      alt: "10元赠送余额",
    },
    {
      image: require("../../../../assets/webActivity/newYear/lotteryImg/coin_100.png"),
      alt: "100元赠送余额",
    },
  ],
  awardList: [],
});

const props = defineProps({
  // 剩余开箱数
  cjnum: {
    type: Number,
    default: 0,
  },
  // 第一名
  first: {
    type: Object,
    default: () => {},
  },
});

onMounted(() => {
  initSwiper();
});

import "swiper/swiper-bundle.min.js";
import { Swiper, Pagination, Autoplay } from "swiper";
import "swiper/modules/effect-creative/effect-creative.min.css";
var mySwiper = "";
var slides = ref(null);

Swiper.use([Pagination, Autoplay]);
const initSwiper = () => {
  mySwiper = new Swiper(".swiper", {
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: false,
      waitForTransition: false,
    },
    speed: 1000, // 滑动速度，单位毫秒
    freeMode: true,
    slidesPerView: "auto", // 每次展示多个图片
    loop: true,
    allowTouchMove: true,
    initialSlide: 1,
    loop: true,
  });
};

import { getNewYearSingle, getNewYearTen } from "@/api/activity";
import { getQueryString } from "../../../../utils/location";
import { Toast } from "vant";

let lotteryFetch = ref(false);

const openBox = async (type) => {
  if (lotteryFetch.value) return;
  lotteryFetch.value = true;
  state.openKey = new Date().getTime();
  // console.log("开始抽奖---------------");
  if (type == 1) {
    try {
      let res = await getNewYearSingle({
        uid: getQueryString("uid"),
      });
      console.log("抽奖结果", res);
      lotteryFetch.value = false;
      console.log("抽奖结果", res.data.data);
      // 根据返回值添加奖品信息
      if (res.data.code == 1) {
        state.openFlag = true;
        subtractCjnum(1);
        // 奖品展示
        state.awardList.push({
          image: res.data.data,
        });
      } else {
        Toast(res.data.msg);
      }
    } catch (error) {
      lotteryFetch.value = false;
      console.log("error", error);
    }
  } else if (type == 10) {
    try {
      let res = await getNewYearTen({
        uid: getQueryString("uid"),
      });
      console.log("抽奖结果", res.data.data);
      lotteryFetch.value = false;
      if (res.data.code == 1) {
        res.data.data.forEach((item) => {
          state.awardList.push({
            image: item,
          });
        });
        state.openFlag = true;

        subtractCjnum(10);
        // 根据返回值添加奖品信息
      } else {
        Toast(res.data.msg);
      }
    } catch (error) {
      lotteryFetch.value = false;
      console.log("error", error);
    }
  }
};
const emit = defineEmits(["scrollTofirst", "subtractCjnum"]);

const subtractCjnum = (num) => {
  emit("subtractCjnum", num);
};

const scrollTofirst = () => {
  emit("scrollTofirst");
};

// 抽奖弹出
const openboxDom = ref(null);
const openBoxPop = () => {
  // console.log("抽奖弹窗弹出---------------", openboxDom.value);
  // 添加类名
  setTimeout(() => {
    state.awardFlag = true;
    state.getAwardflag = true;
    state.awardTitleFlag = true;
  }, 1500);
  setTimeout(() => {
    openboxDom.value.classList.add("lightAction");
  }, 2400);
};

// 抽奖弹窗关闭
const closeBoxPop = () => {
  // console.log("抽奖弹窗关闭---------------");
  // 移除类名
  openboxDom.value.classList.remove("lightAction");
  state.awardFlag = false;
  state.getAwardflag = false;
  state.awardTitleFlag = false;
  state.awardList = [];
};

// 收下按钮
const getAward = () => {
  state.openFlag = false;
};
</script>
<style scoped>
.lottery_content {
  height: 1136px;
  width: 100vw;
  padding: 0 32px;
  background-image: url(../../../../assets/webActivity/newYear/lotteryImg/lottery_bg_spring.png);
  background-size: 100% 100%;
  padding-top: 362px;
  position: relative;
}
.lottery_content .slide_left {
  position: absolute;
  top: 566px;
  left: 32px;
  width: 146px;
  height: 196px;
  animation-iteration-count: infinite;
}

.lottery_content .slide_right {
  position: absolute;
  top: 564px;
  right: 32px;
  width: 156px;
  height: 178px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 30px;
}
.lottery_content .slide_right img {
  width: 90px;
  height: 90px;
  position: relative;
  z-index: 2;
  border-radius: 20px;
}
.lottery_content .slide_right span {
  position: absolute;
  z-index: 2;
  background-image: url(../../../../assets//webActivity//newYear/lotteryImg/avater_title_bg.png);
  background-size: 100% 100%;
  width: 152px;
  height: 44px;
  text-align: center;
  top: 106px;
  padding: 0 30px;
}
:deep(.van-notice-bar) {
  width: 100%;
  background: none;
  color: #333333;
  padding: 0 0 8px;
  text-align: center;
  height: 44px;
  color: #fff;
  font-size: 20px;
  line-height: 30px;
}
:deep(.van-notice-bar__wrap) {
  justify-content: center;
}

.lottery_content .slide_right::after {
  content: "";
  display: block;
  width: 100%;
  height: 100%;
  background-image: url(../../../../assets/webActivity/newYear/lotteryImg/avater_bg.png);
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.lottery_content > ul {
  width: 686px;
  height: 164px;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 30px;
  padding: 20px;
  display: flex;
  align-items: center;
  overflow: auto;
  scrollbar-width: none;
}

.swiper {
  display: flex;
  flex-wrap: nowrap;
  width: 632px;
  overflow: auto;
  touch-action: pan-y pinch-zoom;
  scrollbar-width: none;
}
.swiper img {
  width: 122px;
  height: 122px;
  margin-right: 18px;
}
.lottery_content ul li {
  /* width: 188px; */
  flex-shrink: 0;
}

/* 宝箱样式 */
.lottery_content .box {
  width: 384px;
  height: 384px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 34px;
  position: relative;
}
.lottery_content .box p {
  position: relative;
  z-index: 2;
  left: 25%;
  height: 44px;
  width: fit-content;
  background: linear-gradient(180deg, #b3d941 0%, #90bb43 100%);
  border-radius: 46px;
  border: 2px solid #ffffff;
  color: #fff;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  font-weight: 600;
  margin-top: -35px;
  animation-iteration-count: infinite;
}
.lottery_content .box p::before {
  content: "";
  position: absolute;
  width: 18px;
  height: 18px;
  background-color: #b3d941;
  border: 2px solid #ffffff;
  border-right: #90bb43;
  border-bottom: #90bb43;
  top: -10px;
  z-index: -1;
  transform: rotate(45deg);
}
/* 开启按钮 */
.lottery_content .open_box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 18px;
  padding: 0 40px;
}
.lottery_content .open_box button {
  width: 302px;
  height: 128px;
  border: none;
  background-color: transparent;
}

.lottery_content .open_box button:nth-of-type(1) {
  background-image: url(../../../../assets/webActivity/newYear/lotteryImg/open_one.png);
  background-size: 100% 100%;
}
.lottery_content .open_box button:nth-of-type(1):active {
  background-image: url(../../../../assets/webActivity/newYear/lotteryImg/open_one_click.png);
  background-size: 100% 100%;
}
.lottery_content .open_box button:nth-of-type(2) {
  background-image: url(../../../../assets/webActivity/newYear/lotteryImg/open_ten.png);
  background-size: 100% 100%;
}
.lottery_content .open_box button:nth-of-type(2):active {
  background-image: url(../../../../assets/webActivity/newYear/lotteryImg/open_ten_click.png);
  background-size: 100% 100%;
}

/* 宝箱弹出动画 */
.lottery_content :deep(.van-overlay) {
  background-color: rgba(0, 0, 0, 0.8);
}
:deep(.open_box_pop) {
  background-color: rgba(255, 255, 255, 0);
  overflow: hidden;
  width: 100vw;
}
:deep(.open_box_pop) .open_pop_content {
  width: 100vw;
  height: 774px;
  position: relative;
}
:deep(.open_box_pop) .lightAction::before {
  content: "";
  width: 90%;
  height: 90%;
  position: absolute;
  top: 0;
  left: 5%;
  background: url(../../../../assets/webActivity/newYear/lotteryImg/lottery_light.png)
    no-repeat;
  background-size: 100% 100%;
  background-position: center;
  z-index: 2;

  transform-origin: center;
  animation: rotate 3s linear infinite;
}
:deep(.open_box_pop) .lightAction::after {
  content: "";
  width: 90%;
  height: 90%;
  position: absolute;
  top: 0;
  left: 10%;
  background: url(../../../../assets/webActivity/newYear/lotteryImg/lottery_light_bottom.png)
    no-repeat;
  background-size: 100% 100%;
  background-position: center;
  z-index: -1;

  /* 无限旋转 */
  transform-origin: center;
  animation: rotate 3s linear infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* 单抽 */
:deep(.open_box_pop) .open_pop_content ul {
  position: absolute;
  z-index: 3;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  top: 0;
  padding-top: 260px;
}
:deep(.open_box_pop) .open_pop_content ul img {
  width: 190px;
  height: 190px;
}
/* 十连抽 */
:deep(.open_box_pop) .open_pop_content ul.awardList {
  padding: 12px;
  padding-top: 230px;
  height: auto;
  align-items: center;
  justify-content: space-around;
}
:deep(.open_box_pop) .open_pop_content ul.awardList img {
  width: 124px;
  height: 124px;
}
:deep(.open_box_pop) .open_pop_content .award_title {
  width: 286px;
  height: 80px;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  z-index: 9;
}
/* 收下按钮 */
.get_btn {
  width: 314px;
  height: 122px;
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 9;
}
</style>
